import { render, staticRenderFns } from "./bulk-buy-code.vue?vue&type=template&id=34ca2b36&scoped=true&"
import script from "./bulk-buy-code.vue?vue&type=script&lang=js&"
export * from "./bulk-buy-code.vue?vue&type=script&lang=js&"
import style0 from "./bulk-buy-code.scss?vue&type=style&index=0&id=34ca2b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ca2b36",
  null
  
)

export default component.exports